/**
 * Extracción de recibos de papel por foto — contrato sin construir: aquí viven el esquema de
 * validación y un extractor de mentira para las pruebas, y la implementación con Gemini se conecta
 * cuando exista su clave. La imagen es dato NO confiable: la salida SIEMPRE se valida.
 */
import { z } from 'zod';

export const esquemaReciboExtraido = z.object({
  nitEmisor: z.string().regex(/^\d{5,15}$/).nullable(),
  fecha: z.string().regex(/^\d{4}-\d{2}-\d{2}$/).nullable(),
  subtotal: z.number().int().nonnegative().nullable(),
  iva: z.number().int().nonnegative().nullable(),
  total: z.number().int().positive().nullable(),
  confianza: z.enum(['alta', 'media', 'baja']),
});

export type ReciboExtraido = z.infer<typeof esquemaReciboExtraido>;

export interface ExtractorRecibo {
  extraer(imagenJpegBase64: string): Promise<ReciboExtraido>;
}

/** Mock determinista para tests y para el flujo con el bandera apagado. */
export const extractorMock: ExtractorRecibo = {
  extraer(imagenJpegBase64: string): Promise<ReciboExtraido> {
    if (!imagenJpegBase64 || imagenJpegBase64.length < 100) {
      return Promise.resolve({ nitEmisor: null, fecha: null, subtotal: null, iva: null, total: null, confianza: 'baja' });
    }
    return Promise.resolve({
      nitEmisor: '900123456',
      fecha: '2026-08-01',
      subtotal: 42000,
      iva: 0,
      total: 42000,
      confianza: 'media',
    });
  },
};

/** Valida una salida cruda (p. ej. JSON devuelto por el modelo) contra el esquema. */
export function validarReciboExtraido(crudo: unknown): ReciboExtraido | null {
  const r = esquemaReciboExtraido.safeParse(crudo);
  return r.success ? r.data : null;
}
